/* __next_internal_client_entry_do_not_use__ getColCount,Default auto */ import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { tv } from 'tailwind-variants';
import { withStandardComponentWrapper } from 'helpers/HOC';
import { PlaceholderWrapper } from 'helpers/SitecoreWrappers/PlaceholderWrapper/PlaceholderWrapper';
import useIsEditing from 'lib/hooks/useIsEditing';
import { EditingHelpText } from 'helpers/Editing/EditingHelpText';
import useDictionary from 'lib/hooks/useDictionary';
import { getTestProps } from 'lib/testing/utils';
import { BackgroundColorProvider } from 'lib/context/BackgroundColorContext';
import { editingHydrationProps } from 'lib/hooks/useEditingHydrationProps';
export const getColCount = (count)=>{
    if (count === 1) return '1';
    if (count === 2) return '2';
    return '3';
};
const Stats = (props)=>{
    const { params } = props;
    const { DynamicPlaceholderId, RenderingIdentifier } = params || {};
    const phKey = `stats-${DynamicPlaceholderId}`;
    const { wrapper } = TAILWIND_VARIANTS();
    const isEditing = useIsEditing();
    const { getDictionaryValue } = useDictionary();
    const backgroundColor = params?.backgroundColor || 'Default';
    // Show placeholder in editing mode if no title is provided
    if (isEditing) {
        return /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx(EditingHelpText, {
                    priority: "warning",
                    children: getDictionaryValue('StatsAddMoreItemsHelpText') || 'Add more StatsItems above or below to display additional stats in this row.'
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: wrapper(),
                    "data-component": "authorable/shared/lists/stats",
                    ...editingHydrationProps(isEditing),
                    id: RenderingIdentifier,
                    children: /*#__PURE__*/ _jsx(PlaceholderWrapper, {
                        name: phKey,
                        rendering: props.rendering,
                        render: (components)=>{
                            const colCount = getColCount(components.length);
                            const { statsGrid } = TAILWIND_VARIANTS({
                                colCount
                            });
                            return /*#__PURE__*/ _jsx(BackgroundColorProvider, {
                                backgroundColor: backgroundColor,
                                children: /*#__PURE__*/ _jsx("ul", {
                                    className: statsGrid(),
                                    children: components.map((comp, index)=>/*#__PURE__*/ _jsx("li", {
                                            children: comp
                                        }, index))
                                })
                            });
                        }
                    })
                })
            ]
        });
    }
    return /*#__PURE__*/ _jsx("div", {
        className: wrapper(),
        "data-component": "authorable/shared/lists/stats",
        ...editingHydrationProps(isEditing),
        id: RenderingIdentifier,
        ...getTestProps(`component-stats-${props?.rendering?.uid}`),
        children: /*#__PURE__*/ _jsx(PlaceholderWrapper, {
            name: phKey,
            rendering: props.rendering,
            render: (components)=>{
                const colCount = getColCount(components.length);
                const { statsGrid } = TAILWIND_VARIANTS({
                    colCount
                });
                return /*#__PURE__*/ _jsx(BackgroundColorProvider, {
                    backgroundColor: backgroundColor,
                    children: /*#__PURE__*/ _jsx("ul", {
                        className: statsGrid(),
                        children: components.map((comp, index)=>/*#__PURE__*/ _jsx("li", {
                                children: comp
                            }, index))
                    })
                });
            },
            ...getTestProps(`stats-ph`)
        })
    });
};
const TAILWIND_VARIANTS = tv({
    slots: {
        wrapper: [
            'w-full'
        ],
        title: [
            'text-typography-font-size-header-xLarge',
            'text-typography-font-family-header',
            'font-bold',
            'text-color-text-text',
            'mb-spacing-spacing-16',
            'lg:mb-spacing-spacing-8',
            'text-center'
        ],
        statsGrid: [
            'grid',
            'gap-layout-base-gutter'
        ]
    },
    variants: {
        colCount: {
            '1': {
                statsGrid: [
                    'grid-cols-1'
                ]
            },
            '2': {
                statsGrid: [
                    'grid-cols-1',
                    'lg:grid-cols-2'
                ]
            },
            '3': {
                statsGrid: [
                    'grid-cols-1',
                    'lg:grid-cols-3'
                ]
            }
        }
    },
    defaultVariants: {
        colCount: '1'
    }
});
export const Default = withStandardComponentWrapper(Stats, false);
